__webpack_require__.p = "https://static.age.awaze.com/search-mfe/4b6f123/_next/";